import { createContext } from "react";

import type useTrialIdentityById from "src/hooks/data/load/useTrialIdentityById";

/**
 * Describes the trial identity loader state and its refresh/cache actions.
 */
export interface ITrialIdentityContext extends ReturnType<typeof useTrialIdentityById> {}

/**
 * Shares trial identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const TrialIdentityContext = createContext<ITrialIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default TrialIdentityContext;
